import { createFileRoute, Link } from "@tanstack/react-router";
import { SetupCopyBlock } from "@/components/setup/SetupCopyBlock";

export const Route = createFileRoute("/docs/deleting-posts")({
	component: DeletingPosts,
});

function DeletingPosts() {
	return (
		<article className="space-y-10">
			<div className="space-y-2">
				<h1 className="text-2xl font-medium tracking-tight">Deleting posts</h1>
				<p className="text-sm text-muted-foreground">
					How to remove posts from AgentReacher.
				</p>
			</div>
			<div className="space-y-4 text-sm leading-relaxed text-muted-foreground">
				<p>Tell your assistant things like:</p>
				<div className="grid gap-2">
					<SetupCopyBlock
						text="Delete the draft I created earlier today."
						multiline
					/>
					<SetupCopyBlock
						text="Remove the scheduled post about the meetup."
						multiline
					/>
				</div>
				<p>
					The assistant uses{" "}
					<code className="rounded bg-muted px-1.5 py-0.5 text-xs font-mono text-foreground">
						postPlan
					</code>
					. Any post in AgentReacher can be deleted from the workspace,
					including drafts, scheduled posts, failed posts, processing posts, and
					already published posts.
				</p>

				<h2 className="text-base font-medium text-foreground pt-2">
					Good to know
				</h2>
				<p>
					Deleting a scheduled post cancels the scheduled publish. Deleting a
					post that has already been published removes it from AgentReacher but
					does not delete it from the social platform itself.
				</p>
			</div>

			<div className="flex items-center gap-4 text-sm">
				<Link
					to="/docs/editing-posts"
					className="text-muted-foreground hover:text-foreground transition-colors"
				>
					&larr; Editing posts
				</Link>
				<Link
					to="/docs/scheduling-posts"
					className="text-primary hover:text-primary/80 transition-colors ml-auto"
				>
					Scheduling posts &rarr;
				</Link>
			</div>
		</article>
	);
}
